// WidthContext.js
import React from 'react';

const WidthContext = React.createContext(0); // Default width
export default WidthContext;